import CheckmarkCircle from "@/common/partials/checkmarkCircle"

function RadioInputContainer({
  selected = false,
  children,
  className = "",
  type = ""
}) {
  return (
    <div
      className={[
        "flex justify-between mb-4 border border-black-100/25 rounded group",
        type === "small" ? "px-5 py-3" : "px-6 py-4",
        className,
        selected
          ? "bg-green-25 hover:bg-green-25 hover:border-green-100 border-green-100 selected"
          : "hover:bg-green-25 hover:border-green-100"
      ].join(" ")}>
      {children}
    </div>
  )
}

export function RadioInputTitle({ selected, title }) {
  return (
    <div className="flex items-center text-lg font-semibold">
      <CheckmarkCircle selected={selected} />
      {title}
    </div>
  )
}

export default RadioInputContainer
